import type { ProductFeedbackType } from '@doneverse/shared'
import { ChevronRight } from 'lucide-react'
import { FEEDBACK_FORMS } from './feedbackForms'
import styles from './FeedbackTypePicker.module.css'

/**
 * The feedback button opens this, not a form. Choosing a type first is what
 * lets each form ask its own questions — a bug needs reproduction steps and
 * urgency, an idea needs the problem it solves and how much it matters.
 */
export function FeedbackTypePicker({ onSelect }: { onSelect: (type: ProductFeedbackType) => void }) {
  return (
    <div className={styles.list}>
      {FEEDBACK_FORMS.map(({ type, pickerTitle, pickerPrompt, icon: Icon }) => (
        <button
          key={type}
          type="button"
          className={styles.card}
          onClick={() => onSelect(type)}
          data-testid={`feedback-type-${type}`}
        >
          <span className={styles.iconWrap}>
            <Icon className="h-5 w-5" />
          </span>
          <span className={styles.text}>
            <span className={styles.title}>{pickerTitle}</span>
            <span className={styles.prompt}>{pickerPrompt}</span>
          </span>
          <ChevronRight className={styles.chevron} />
        </button>
      ))}
    </div>
  )
}
